import React from "react";
import { Button, Icon, Input, Table } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { getFirebaseData } from "../../redux/actions/network";
import { deleteStudentGroup } from "../../redux/actions/groups";
import {
  selectGroupsByColegio,
  selectStudentsByGroupKey
} from "../../redux/selectors/groups";
import { selectCurrentUser } from "../../redux/selectors/auth";

class ColegioGruposList extends React.Component {
  state = {
    searchText: ""
  };

  componentDidMount() {
    this.props.getFirebaseData();
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    )
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      {
        title: "Identificador Grupo",
        dataIndex: "key",
        key: "idgroup",
        width: "20%"
      },
      {
        title: "Estudiantes",
        dataIndex: "key",
        key: "estudiantes",
        render: x => {
          const students = this.props.selectStudents(x);
          return students.map((student, i) => {
            return (
              <div key={i}>
                {student.nombre} {student.nivel}
                {student.identificadorNivel}
              </div>
            );
          });
        },
        width: "20%"
      },
      {
        title: "Nombre Grupo",
        dataIndex: "nombreGrupo",
        key: "nombreGrupo",
        width: "20%"
      },
      {
        title: "Curso",
        dataIndex: "key",
        key: "estudiantesCurso",
        render: x => {
          const students = this.props.selectStudents(x);
          return (
            <div>
              {students && students[0] && students[0].nivel}
              {students && students[0] && students[0].identificadorNivel}
            </div>
          );
        },
        width: "20%"
      },
      {
        title: "Colegio",
        dataIndex: "colegio",
        key: "colegio",
        width: "20%"
      },
      {
        title: "Ver respuestas grupo",
        dataIndex: "key",
        key: "respuestasEstudiantes",
        render: x => <Link to={`/grupos/${x}`}> Ver respuestas grupo</Link>
      }
    ];

    return (
      <React.Fragment>
        <Table
          columns={columns}
          rowKey={group => group.key}
          dataSource={this.props.groups}
          loading={this.state.loading}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getFirebaseData, deleteStudentGroup }, dispatch);

const mapStateToProps = state => {
  const currentUser = selectCurrentUser(state);
  const selectStudents = groupKey => selectStudentsByGroupKey(state, groupKey);
  const groups = selectGroupsByColegio(state, currentUser.colegio);
  return {
    groups,
    selectStudents,
    currentUser
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ColegioGruposList);
